
export const CMS_FIELD_PLUGIN_ID = 'cms'
export interface CmsFieldPlugin {
  // marks CMS-internal field, that should not be displayed anywhere
  internal: boolean
}

export interface KnownFieldPlugins {
  [CMS_FIELD_PLUGIN_ID]?: CmsFieldPlugin
}

export type FieldPlugins = KnownFieldPlugins & Record<string, object>
export type FieldPluginId = keyof KnownFieldPlugins
export type FieldPlugin = Required<KnownFieldPlugins>[FieldPluginId]
